export const environment = {
    production: false,
    //++urlserv: 'http://localhost:55958',
    //urlserv: 'http://localhost:52080',
    //+++urlserv: 'http://213.8.209.141:52080',

    //urlserv: "https://AutomationTest.ishur.biz", //https
    //+++urlserv: 'https://localhost:44332/', //https iis express

    //+++urlservbeautech: 'http://localhost:30938',
    //+++urlservbeautech: 'http://213.8.209.141:52090',

    urlservbeautech: "https://webapitest.optimus.co.il", //https

    urlAWS: "https://12x2ym9xp9.execute-api.eu-north-1.amazonaws.com",

    urlsocketio: "localhost:3000/diary",
    urlonlinecountersocket: "localhost:3000",
};

export const activeTemplates: Map<number, boolean> = new Map<number, boolean>([
    [2, true], // Visit
    [3, true], // Birthday
    [4, true], // MeetingCreate
    [5, true], // MeetingCancel
    [6, true], // MeetingDateChange
    [7, true], // MeetingTimeChange
    [8, true], // AutomaticClosingCash
    [9, true], // ThanksForRecomandation
    [10, true], // ThanksForVisit
    [11, true], // EndDay
    [12, true], // SendCash
]);

export const screenId = {
    Automation: {
        // 1
        mainsms: 101,
        templatesms: 102,
    },
    Clients: {
        // 2
        clientbase: 201,
        custcardview: 205,
    },
    Calendar: {
        // 3
        calendarview: 301,
    },
};

export const isSidebarExpanded: boolean = true;

export const isAIAssistantEnabled: boolean = true;

export const isErudaEnabled: boolean = false;

export const isOnlineCounterEnabled: boolean = false;
